import * as R from 'ramda';
import React from 'react';
import {DateUtils} from "react-day-picker";

import {translate} from 'iss/strings';
import {createEvent, eventStates} from 'iss/service/EvaluationEventService';
import {runBatchOps} from 'iss/utils/batchOps';
import dates from 'iss/utils/dates';
import {ActivationList} from 'iss/widgets/ActivationList';
import {Field, MultiDateChooser} from 'iss/widgets/Forms';
import {WarningBox} from 'iss/widgets/MessageBox';
import {ModalForm} from 'iss/widgets/batchOps/ModalForm';
import {listEventFailuresWithMessage} from 'iss/widgets/batchOps/activation/BatchOpEventFailure';
import validators from 'iss/widgets/form/validation/validators';

const createEventsBatchOp = {
  id: "createEvents",
  title: "activationOperations.createEvents.title",
  progressMessage: "activationOperations.createEvents.progressMessage",
  components: {
    settings: ({operationTargets, onCancel, startOperation}) =>
      <ModalForm proceedText={translate('activationOperations.createEvents.createEvents')} proceedLook="danger"
        initialValues={{createMode: 'all'}}
        onSubmit={(data) => startOperation(createEvents(operationTargets, data))}
        onCancel={onCancel}>
        <MultiDateChooser id="plannedDates" label="activationOperations.createEvents.datesToAdd" valuePath="plannedDates" validate={validators.chooseAtLeastOne} />

        <OverlappingDateWarnings targets={operationTargets} />

        <ActivationList activations={operationTargets} compact extraColumns={[
            {
              header: translate('activationOperations.createEvents.unFinishedEventDates'),
              accessor: (target) => {
                return getUnfinishedEvents(target).map(formatEventDate).join(", ");
              }
            }
          ]}/>
      </ModalForm>,
    success: <p>{translate("activationOperations.createEvents.success")}</p>,
    failure: listEventFailuresWithMessage("activationOperations.createEvents.failure"),
  },
};

function OverlappingDateWarnings({targets}) {
  return <Field valuePath="plannedDates" >
    {fieldApi => (fieldApi.getValue() || []).map(date => {
      const count = countTargetsWithEventDate(targets, date);
      return count > 0 && <WarningBox key={date} message={translate('activationOperations.createEvents.conflictingEvents', {count, date: dates.format(date)})} />;
    })}
  </Field>;
}

function createEvents(targets, {plannedDates}) {
  const opsByTarget = targets.map((target) => (
    plannedDates.filter(date => (countTargetsWithEventDate([target], date) == 0))
      .map(plannedDate => (
      {
        operation: createEvent({
          activationId: target.id,
          plannedDate: dates.formatUTC(plannedDate),
        }),
        activation: target, event: {plannedDate}
      }
    ))
  ));
  return runBatchOps(R.unnest(opsByTarget));
}

function getUnfinishedEvents(target) {
  return target.events.filter(R.propEq("READY_FOR_EVALUATION", 'state'));
}

function countTargetsWithEventDate(targets, date) {
  return targets.filter(({events}) =>
    R.any(({plannedDate, state}) => state !== eventStates.cancelled && DateUtils.isSameDay(dates.fromJson(plannedDate), date), events)
  ).length;
}

const formatEventDate = R.pipe(R.prop('plannedDate'), dates.fromJson, dates.format);

export default createEventsBatchOp;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/activation/createEvents.jsx